import type { Doc, Ref } from '@hcengineering/core'
import type { Asset, IntlString, Plugin } from '@hcengineering/platform'
import { plugin } from '@hcengineering/platform'
import type { AnyComponent } from '@hcengineering/ui'

/**
 * @public
 */
export const shellId = 'dztek-shell' as Plugin

/**
 * localStorage key of the sidebar's collapsed state.
 * @public
 */
export const SHELL_COLLAPSED_KEY = 'hooli-shell-collapsed'

/**
 * localStorage key prefix that tracks, per viewlet id, the hash of the
 * site's viewlets.json config last written into that viewlet's
 * ViewletPreference by this add-on (viewletOverrides.ts, "table-column
 * overrides" in addons/shell/README.md). Suffixed with the viewlet id.
 * @public
 */
export const SHELL_VIEWLET_PREF_KEY_PREFIX = 'hooli-shell-viewlet-pref-'

export default plugin(shellId, {
  app: {
    Shell: '' as Ref<Doc>
  },
  component: {
    ShellExtension: '' as AnyComponent,
    Sidebar: '' as AnyComponent,
    PersonCompany: '' as AnyComponent
  },
  string: {
    Shell: '' as IntlString,
    Description: '' as IntlString,
    Applications: '' as IntlString,
    More: '' as IntlString,
    Collapse: '' as IntlString,
    Expand: '' as IntlString,
    ShowNavigator: '' as IntlString,
    HideNavigator: '' as IntlString,
    SwitchWorkspace: '' as IntlString,
    Settings: '' as IntlString,
    CustomizeApps: '' as IntlString,
    Account: '' as IntlString
  },
  icon: {
    Shell: '' as Asset,
    Collapse: '' as Asset,
    Expand: '' as Asset,
    Menu: '' as Asset
  }
})
